import { Map } from 'immutable';
import { LoadingStatusEnum } from '../../../../../lib/enums';
import { actionTypes } from '../../../../controller';

const {
	START_FETCH_CAPTCHA,
	FETCH_CAPTCHA_SUCCESS,
	FETCH_CAPTCHA_FAILED,

	START_DETECT_CAPTCHA,
	DETECT_CAPTCHA_SUCCESS,
	DETECT_CAPTCHA_FAILED,
} = actionTypes;
const {
	NONE,
	LOADING,
	SUCCESS,
	FAILED,
} = LoadingStatusEnum;
const initialState = Map({
	data: Map(),

	captchaLoadingStatus: NONE,
	captchaLoadingStatusMessage: '',

	detectCaptchaLoadingStatus: NONE,
	detectCaptchaLoadingStatusMessage: '',
});

export default function captcha(state = initialState, action) {
	switch (action.type) {
		case START_FETCH_CAPTCHA:
			return state
				.set('captchaLoadingStatus', LOADING)
				.set('data', Map())
				.set('detectCaptchaLoadingStatus', NONE);

		case FETCH_CAPTCHA_SUCCESS:
			return state
				.set('data', Map(action.data))
				.set('captchaLoadingStatus', SUCCESS);

		case FETCH_CAPTCHA_FAILED:
			return state
				.set('captchaLoadingStatus', FAILED)
				.set('captchaLoadingStatusMessage', action.errorMessage);

		case START_DETECT_CAPTCHA:
			return state.set('detectCaptchaLoadingStatus', LOADING);

		case DETECT_CAPTCHA_SUCCESS:
			return state.set('detectCaptchaLoadingStatus', SUCCESS);

		case DETECT_CAPTCHA_FAILED:
			return state
				.set('detectCaptchaLoadingStatus', FAILED)
				.set('detectCaptchaLoadingStatusMessage', action.errorMessage);

		default:
			return state;
	}
}
